
import { Base } from '../base-component';

import './form-item-access-quote.component.scss';

export class FormItemAccessQuote extends Base {

	form: HTMLFormElement;
	submitBtn: Element[];

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = Array.from(this.element.querySelectorAll('.js-apply-now__button'));

	}

	bindEvents() {

		this.submitBtn.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.form.querySelectorAll('input, select');
			const validation = this.validationService.validate(formFields);
			const valid = Array.from(this.form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.formsService.detect(this.form, this.element.querySelector('.form__loader--container'), this.element.querySelector('.form__thankyou--container'));
			}
		}));

	}

}



// WEBPACK FOOTER //
// ./components/form-item-access-quote/form-item-access-quote.component.ts